import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import Global from '../../../Services/Common/Global';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import { M_NOT_BASIC_02_Schema } from './M_NOT_BASIC_02_Schema';
import useDeleteMutation from './../../../Hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';
import Store from '../../../Store/Store';

const extractRows = (res) => {
  if (res == null) return [];
  if (Array.isArray(res)) return res;
  if (Array.isArray(res.data)) return res.data;
  if (Array.isArray(res.Data)) return res.Data;
  return [];
};

/** GetCompanyInfo — 회사(선택) 기준 사업장 목록 */
export const fetchCompanySites = async (coCd) => {
  const userInfo = Store.getState().BaseInfo.userInfo;
  const params = mapParamsBySchema(M_NOT_BASIC_02_Schema.mapper.companyInfo, {
    userInfo,
    search: { coCd: coCd || userInfo?.coCd },
  });
  const res = await apiRequest('post', Global.urls.Utility.getCompanyInfo, params);
  return extractRows(res);
};

/** GetDepBasicR1 — 사업장 기준 부서 목록 */
export const fetchDepartments = async (custCd, coCd) => {
  const userInfo = Store.getState().BaseInfo.userInfo;
  const params = mapParamsBySchema(M_NOT_BASIC_02_Schema.mapper.depBasic, {
    userInfo,
    search: { custCd, coCd: coCd || userInfo?.coCd },
  });
  const res = await apiRequest('post', Global.urls.Depart.getDepBasicR1, params);
  return extractRows(res);
};

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_02_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasic01R1, params);
  }, successOptions);
};
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_02_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasicR2, params);
  }, successOptions);
};
export const useSave1 = () =>
  useSaveMutation(async (rows) => {
    const userInfo = Store.getState().BaseInfo.userInfo;
    const payload = mapRowsBySchema(rows, M_NOT_BASIC_02_Schema.mapper.save1, {
      userInfo,
    });
    return apiRequest('post1', Global.urls.Notice.saveNotBasicU1, payload);
  });
export const useSave2 = () =>
  useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_NOT_BASIC_02_Schema.mapper.save2);
    return apiRequest('post1', Global.urls.Notice.saveNotBasicU2, payload);
  });
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_NOT_BASIC_02_Schema.mapper.delete1);
    return apiRequest('post1', Global.urls.Notice.deleteNotBasicD1, payload);
  }, options);
};
